<template>
  <div class="pop-one">

    <div class="a-box beige">
      <div class="pure-g">
        <div class="pure-u-1-1 pure-u-md-1-2 fixed-text-box" v-html="$lang.f1_1_header"></div>
        <div class="pure-u-1-2 pure-u-md-1-2 icon-holder">
          <div class="icon f1-1"></div>
        </div>
      </div>
    </div>

    <div class="p-section maroon">
      <div class="p-box pure-g">
        <div class="box-left pure-u-1-1 pure-u-md-1-2">
          <h2 v-html="$lang.f1_2_big"></h2>
          <p v-html="$lang.f1_2_small"></p>
        </div>
        <div class="pure-u-1-1 pure-u-md-1-2">
            <div class="icon-header right pure-g">
              <h3 class="pure-u-2-3" v-html="$lang.p_2_sec_4_document"></h3>
              <a :href="'./static/documents/08.pdf'" download="studiematerial_08" class="icon p-2-sheet-0 pure-u-1-3" v-touch:tap="downloadFact1Document"></a>
            </div>

        </div>
      </div>
    </div>

    <div class="a-box fact-gen">
      <div class="pure-g">
        <div class="f-g-left  pure-u-1-1 pure-u-md-1-2">
          <div class="pure-g">
            <div class="f-g-txt pure-u-3-5">
              <h4 v-html="$lang.f1_3_1_big"></h4>
              <p v-html="$lang.f1_3_1_small"></p>
            </div>
            <div class="f-g-icon-holder pure-u-2-5">
              <div class="icon f1-2-1"></div>
            </div>
          </div>
        </div>
        <div class="f-g-right pure-u-1-1 pure-u-md-1-2">
          <div class="pure-g">
            <div class="f-g-txt pure-u-3-5">
              <h4 v-html="$lang.f1_3_2_big"></h4>
              <p v-html="$lang.f1_3_2_small"></p>
            </div>
            <div class="f-g-icon-holder pure-u-2-5">
              <div class="icon f1-2-2"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="p-section maroon">
      <div class="p-box pure-g">
        <div class="box-left pure-u-1-1 pure-u-md-1-2">
          <h2 v-html="$lang.f1_4_big"></h2>
          <p v-html="$lang.f1_4_small"></p>
        </div>
        <div class="pure-u-1-1 pure-u-md-1-2"></div>
      </div>
    </div>

    <div class="lvl-section regular">
      <div class="pure-g">
        <div class="lvl-box pure-u-1-1 pure-u-md-1-3">
          <div class="lvl-header">
            <div class="icon f1-3-1"></div>
            <h4 v-html="$lang.f1_5_1_header"></h4>
          </div>
          <div class="lvl-body" v-html="$lang.f1_5_1_txt"></div>
        </div>
        <div class="lvl-box pure-u-1-1 pure-u-md-1-3">
          <div class="lvl-header">
            <div class="icon f1-3-2"></div>
            <h4 v-html="$lang.f1_5_2_header"></h4>
          </div>
          <div class="lvl-body" v-html="$lang.f1_5_2_txt"></div>
        </div>
        <div class="lvl-box pure-u-1-1 pure-u-md-1-3">
          <div class="lvl-header">
            <div class="icon f1-3-3"></div>
            <h4 v-html="$lang.f1_5_3_header"></h4>
          </div>
          <div class="lvl-body" v-html="$lang.f1_5_3_txt"></div>
        </div>
      </div>
    </div>

    <div class="p-section maroon">
      <div class="p-box pure-g">
        <div class="box-left pure-u-1-1 pure-u-md-1-2">
          <h2 v-html="$lang.f1_6_big"></h2>
          <p v-html="$lang.f1_6_small"></p>
        </div>
        <div class="pure-u-1-1 pure-u-md-1-2"></div>
      </div>
    </div>

    <!-- Big slider -->
    <bg-slider
      :slides="bigSlider"
    ></bg-slider>

    <div class="p-section maroon">
      <div class="p-box pure-g">
        <div class="box-left pure-u-1-1 pure-u-md-1-2" v-touch:tap="toggleRefs">
          <h2 class="toggle-ref">{{$lang.refs}} <span :class="{'open': showRefs}"></span></h2>
        </div>
        <div class="pure-u-1-1 pure-u-md-1-2"></div>
      </div>
    </div>

    <!-- Refferens -->
    <div class="lvl-section refs">
      <transition name="show-ref">
        <div v-show="showRefs" class="pure-g refs-container">
          <div class="lvl-box refs pure-u-1-1 pure-u-md-1-2">
            <div class="lvl-body" v-html="$lang.f1_ref_1"></div>
          </div>
          <div class="lvl-box refs pure-u-1-1 pure-u-md-1-2">
            <div class="lvl-body" v-html="$lang.f1_ref_2"></div>
          </div>
          <!--<div class="lvl-box refs pure-u-1-1 pure-u-md-1-3">-->
            <!--<div class="lvl-body" v-html="$lang.f1_ref_3"></div>-->
          <!--</div>-->
        </div>
      </transition>
    </div>

  </div>
</template>

<script>
import BGSlider from '../../../components/big-slider'
import DataSlider from '../../../assets/data/fact1_b_s.json'
import PDFS from '../../../assets/data/recourse_pdf.json'

export default {
  name: 'fact-one',
  data () {
    return {
      bigSlider: DataSlider.slides,
      showRefs: false,
      pdfs: PDFS

    }
  },
  methods: {
    toggleRefs () {
      let self = this
      return self.onToggleRefs()
    },
    onToggleRefs () {
      this.showRefs = !this.showRefs
    },
    downloadFact1Document () {
      this.$ga.event('Downloads', 'click', 'Bemotande', 4)
    }
  },
  components: {
    'bg-slider': BGSlider
  }
}
</script>



// WEBPACK FOOTER //
// src/components/facts/fact1/index.vue